<div class="blank-state text-center">
  <div class="">
    <div class="mb-3 pmd-avatar pmd-avatar-dark pmd-avatar-xl d-inline-flex" aria-hidden="true">
      <!-- <span class="material-icons" aria-hidden="true">search_off</span> -->
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        enable-background="new 0 0 24 24"
        xml:space="preserve"
        aria-hidden="true"
      >
        <g>
          <path
            d="M10.9,2c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5c1.5,0,3.1-0.4,4.4-1.2l0.3-0.2l3.9,3.9c0.3,0.3,0.6,0.4,1,0.4
    c0.4,0,0.7-0.2,1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.3-0.2-0.7-0.4-1l-3.8-3.9l0.3-0.5c1-1.4,1.5-3.1,1.5-4.8C19.5,5.8,15.6,2,10.9,2z
     M10.9,16.8c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2S14.3,16.8,10.9,16.8z"
          />
          <polygon
            points="13.7,8.9 12.6,7.8 10.9,9.5 9.2,7.8 8,8.9 9.8,10.6 8,12.4 9.2,13.5 10.9,11.7 12.6,13.5 13.7,12.4 12,10.6 	"
          />
        </g>
      </svg>
    </div>
    <h2 class="h3">
      {{ 'COURSE.LIST.NO_DATA_FOUND' | translate }}
    </h2>
    <p class="mb-4">
      {{ 'COURSE.LIST.NO_DATA_FOUND_SUBTITLE' | translate }}
    </p>
  </div>
</div>
